import { publicRequest } from './SuperagentUtils';

const JWT_TOKEN_REGEX = /^e[yw][A-Za-z0-9-_]+\.(?:e[yw][A-Za-z0-9-_]+)?\.[A-Za-z0-9-_]{2,}(?:(?:\.[A-Za-z0-9-_]{2,}){2})?$/;

export const TokenVerificationResult = Object.freeze({
  VALID: 'VALID', INVALID: 'INVALID', EXPIRED: 'EXPIRED', ERROR: 'ERROR',
} as const);

export type TokenVerificationResultType = typeof TokenVerificationResult[keyof typeof TokenVerificationResult];

export interface TokenVerificationResponse {
  status: TokenVerificationResultType;
  message: string;
  accountId?: string;
  outcome?: 'VERIFIED' | 'ALREADY_VERIFIED';
}

export const isJwtTokenValid = (token: string): boolean => JWT_TOKEN_REGEX.test(token);

export const VerifyToken = async (
  token: string, apiEndpoint: string, callback: (response: TokenVerificationResponse) => void
): Promise<void> => {
  if (!isJwtTokenValid(token)) {
    callback({status: 'INVALID', message: 'This verification link is invalid.'});
    return;
  }
  let result: TokenVerificationResponse;
  try {
    const response = await publicRequest.post(apiEndpoint).send({ token })
      .timeout({ response: 10000, deadline: 15000 });
    const {accountId, outcome} = response.body || {};
    result = response.status === 202 && typeof accountId === 'string' && accountId &&
      (outcome === 'VERIFIED' || outcome === 'ALREADY_VERIFIED')
      ? {status: 'VALID', accountId, outcome, message: 'Your email is verified.'}
      : {status: 'ERROR', message: 'We could not confirm the result. Please retry verification.'};
  } catch (error: any) {
    const code = error?.response?.body?.code;
    result = code === '140009'
      ? {status: 'EXPIRED', message: 'This verification link has expired. Sign in to request a new link.'}
      : code === '140008' || code === '140010'
        ? {status: 'INVALID', message: 'This verification link is invalid.'}
        : {status: 'ERROR', message: 'We could not confirm the result. Please retry verification.'};
  }
  callback(result);
};
